import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from 'components/app';
import configureStore from './store/configureStore';
import ReactPWAInstallProvider from 'react-pwa-install';
import agrid from 'agrid-js';
import { AgridProvider } from 'agrid-js/react'
import * as constants from 'constants';

const store = configureStore();
// serviceWorker.register()

let app = (
  <Provider store={store}>
    <BrowserRouter>
      <ReactPWAInstallProvider enableLogging>
        <Suspense fallback={<div>Loading... </div>}>
          <App />
        </Suspense>
      </ReactPWAInstallProvider>
    </BrowserRouter>
  </Provider>
);
if (constants.AGRID_API_KEY && constants.AGRID_API_HOST) {
  // Prevent multiple initializations
  if (!agrid.__initialized) {
    agrid.init(constants.AGRID_API_KEY, {
      api_host: constants.AGRID_API_HOST,
      person_profiles: 'always',
      autocapture: true
    });
    agrid.__initialized = true;
  }
  app = (
    <AgridProvider client={agrid}>
      {app}
    </AgridProvider>
  );
}

ReactDOM.render(
  app,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
